<div class="quote-notes-view">
  <div *ngIf="!(items.length > 0)">
    No notes
  </div>
  <div
    class="flex flex--column notes--block-shadow quote-note-container modern-scroll"
    *ngIf="items && items.length > 0"
  >
    <div class="flex flex--row notes" *ngFor="let item of items">
      <div  class="flex flex--column">
        <span *ngIf="!item.avatarUrl" class="avatar_note"></span>
        <img
          *ngIf="item.avatarUrl"
          class="notes--avatar"
          [src]="item.avatarUrl"
          alt="{{ item.personName }}"
        />
      </div>
      <div class="flex flex--column flex--box notes--info">
        <div
          class="flex flex--row flex--box flex__justify-content--space-between"
        >
          <div>
            {{ item.personName }}
          </div>
          <div textSize="12" textColor="brownish-grey">
            {{ item.date }}
          </div>
        </div>
        <div textSize="12" textColor="brownish-grey" class="flex flex--row message">
          {{ item.message }}
        </div>
      </div>
    </div>
  </div>
</div>